(function(){
    'use strict';
    angular.module('Services').service('SummaryTableService', SummaryTableService);
    SummaryTableService.$inject = [
        'TableLiteFactory',
        '$location',
        'AffiliateService',
        '$routeParams',
        '$filter'
    ];

    function SummaryTableService(
        TableLiteFactory,
        $location,
        AffiliateService,
        $routeParams,
        $filter
    ){
        return function(){
            const tableData ={
                // optionAddOns: {
                //     buttons: [{
                //         class: 'btn-success',
                //         label: 'Report Approvals',
                //         tooltip: 'Report Approvals',
                //         onClick: function () {
                //             $location.path('/affiliates-sales/approval-report');
                //         }
                //     },
                //     {
                //         class: 'btn-primary',
                //         label: 'Create New Profile',
                //         tooltip: 'Create New Profile',
                //         onClick: function () {
                //             $location.path('/affiliates-sales/create');
                //         }
                //     }]
                // },
                headers: [
                    {
                        label: 'Partners',
                        viewName: 'firstName',filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'ACN# Search',
                        viewName: 'acnNo',
                        filterName:'id',
                        filter: {
                            type: 'text',
                            placeholder: 'Search',
                            onSubmit: header => {
                                sendRequest(evaluateFilter(header));
                            }
                        },
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Address',
                        viewName: 'address',
                        filterName:'addressLine1',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Percent Comms.',
                        viewName: 'MTDComms',
                        filterName:'commission.percent',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    },
                    {
                        label: 'Value Comms.',
                        viewName: 'YTDComms',
                        filterName: 'commission.value',
                        headerFn: function(){
                            sort(this.filterName);
                        }
                    }
                ],
                data: []
            }

            const tableActions = new TableLiteFactory(tableData,
                {
                    serviceCallback: AffiliateService.getUserMarketing,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        companyMarketingId:$routeParams.id,
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (item) {
                    item.name = `${item.firstName} ${item.lastName}`;
                    item.acnNo = item.id;
                    item.address = {
                        type:'multiLine',
                        list:[item.addressLine1,item.addressLine2]
                    }
                    item.MTDComms = item.commission.percent;
                    item.YTDComms =  `${$filter('currency')(item.commission.value, '')} ` ;
                    item.actions = {
                        type: 'button',
                        buttons: [{
                            text: 'View / Edit',
                            class: 'btn btn-success',
                            action: row => {
                                $location.path('/affiliates-sales/' +item.id); //: change detailsId to id
                            },
                        },{
                            text: 'Delete',
                            class: 'btn btn-danger',
                            action: row => {
                                removeCompany(item.id);
                            }
                        }
                    ]
                    };
                    tableData.data.push(item);
                });
            };

            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/affiliateTable/SummaryTableService.js